import Reveal from "@/components/base/Reveal";
import { endingKeyPoints } from "@/mocks/drama";

export default function EndingSection() {
  return (
    <section id="ending" className="w-full bg-secondary-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <p className="flex items-center justify-center gap-2 font-label text-sm tracking-[0.3em] text-primary-600">
              <i className="ri-flag-2-line" />
              大 结 局 解 析
            </p>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              《欲望的诱惑》大结局讲了什么
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              大结局要同时完成四件事：收束主线关系、交代对立角色的去向、回收前期伏笔，并留下值得回味的余韵。下面把这几条线索拆开来看。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2">
          {endingKeyPoints.map((point, idx) => (
            <Reveal key={point.title} delay={idx * 70}>
              <div className="flex h-full gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition hover:border-primary-300 md:p-6">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
                  <i className={point.icon} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {point.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    {point.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}